const webComponentScriptId = 'vipps-button-component';
const webComponentCdnUrl = 'https://checkout.vipps.no/checkout-button/v1/vipps-checkout-button.js';

const pendingCallbacks: (() => void)[] = [];
let loadListenerAttached = false;

export const injectOnce = (cb?: () => void): void => {
  if (customElements.get('vipps-mobilepay-button')) {
    cb?.();
    return;
  }

  let scriptEl = document.querySelector<HTMLScriptElement>('#' + webComponentScriptId);

  if (!scriptEl) {
    scriptEl = document.createElement('script');
    scriptEl.id = webComponentScriptId;
    scriptEl.async = true;
    scriptEl.type = 'text/javascript';
    scriptEl.src = webComponentCdnUrl;
    document.body.append(scriptEl);
  }

  if (!cb) return;

  const runPending = () => {
    loadListenerAttached = true;
    pendingCallbacks.forEach((f) => f());
    pendingCallbacks.length = 0;
  };

  pendingCallbacks.push(cb);

  if (!loadListenerAttached) {
    scriptEl.onload = runPending;
  } else {
    cb();
  }
};
